import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { MobileVehiclesService } from 'src/app/services/mobile/mobile-vehicles.service';

@Component({
  selector: 'app-mobile-vehicles-on-port',
  templateUrl: './mobile-vehicles-on-port.component.html',
  styleUrls: ['./mobile-vehicles-on-port.component.css']
})
export class MobileVehiclesOnPortComponent implements OnInit{
  public isLoading: boolean = false;
  public errorMessage: string | null = null;
  public location_type: string = '';
  page: number = 1;
  count: number = 0;
  vehicles: any[] = [];
  searchText: string = '';
  locationId: any=0;

  constructor(
    private activatedRoute:ActivatedRoute,
    private mobileVehiclesService: MobileVehiclesService,
  ){}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.location_type = param['get']('location_type')
    })

    if(this.location_type){

      this.isLoading=true;

      this.getVehiclesByLocationType(this.locationId,'port');
    }else{
      this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
    }
  }

  getVehiclesByLocationType(locationId:string,locationType:string):void{
    this.isLoading=true;

    this.mobileVehiclesService.getVehiclesByLocationType(locationId,locationType)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isLoading=false;
           this.vehicles = [];
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isLoading=false;
          this.vehicles = [];
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
        this.vehicles = [];
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }
}
